import { ClientProjectEntity, ClientRemoteServiceEntity } from '@edgebox/api-rest-client';
import React from 'react';
import { Alert, Container, Nav } from 'react-bootstrap';
import { ApiComponent, IApiComponentState, ProjectSelector, SyncCoreSelector } from '../../../common';
import { withNavigate } from '../../RouterHelper';
import { INavigateProp } from '../../RouterHelper';
import { ContentBox } from '../../Shared/ContentBox';
import { Embed } from '../../Shared/Embed';
import { SiteApplicationType } from '@edgebox/sync-core-data-definitions';

export type BackendAiTab = 'provider' | 'model' | 'prompt-template' | 'prompt-execution';

interface IExternalProps {
  tab: BackendAiTab;
}

interface IState extends IApiComponentState {
  syncCore?: ClientRemoteServiceEntity;
}

class BackendAiManagementComponent extends ApiComponent<IExternalProps & INavigateProp, IState> {
  async load(): Promise<Partial<IState>> {
    return {};
  }

  render() {
    const { syncCore } = this.state;

    const embedByTab: Record<BackendAiTab, 'ai/provider' | 'ai/model' | 'ai/prompt-template' | 'ai/prompt-execution'> = {
      provider: 'ai/provider',
      model: 'ai/model',
      'prompt-template': 'ai/prompt-template',
      'prompt-execution': 'ai/prompt-execution',
    };

    return (
      <Container>
        <h1>AI</h1>
        <p className="text-muted">Manage AI providers, models, prompts and execution logs for the selected Sync Core.</p>

        <ContentBox>
          <SyncCoreSelector
            appType={SiteApplicationType.SyncCore}
            value={syncCore}
            emptyLabel={'Select Sync Core'}
            onSelected={(sc) => this.setState({ syncCore: sc })}
          />
        </ContentBox>

        {syncCore ? (
          <ContentBox>
            <Nav
              variant="tabs"
              activeKey={this.props.tab}
              onSelect={(k) => {
                if (!k) return;
                this.props.navigate(`/backend/syndication/ai/${k as BackendAiTab}`);
              }}
              className="mb-3"
            >
              <Nav.Item>
                <Nav.Link eventKey="provider">Providers</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="model">Models</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="prompt-template">Prompts</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="prompt-execution">Executions</Nav.Link>
              </Nav.Item>
            </Nav>

            <Embed embed={embedByTab[this.props.tab]} scope="configuration" syncCore={syncCore} options={{}} />
          </ContentBox>
        ) : (
          <Alert variant="light">Select a Sync Core to start.</Alert>
        )}
      </Container>
    );
  }
}

export const BackendAiManagement = withNavigate(BackendAiManagementComponent);
